import React from 'react'
import { Badge } from '@chakra-ui/react'

function FileStatus({file}) {
    return file?.status === 'processing' ? <Badge colorScheme='orange'>Processing</Badge> : null
}

export default FileStatus